import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import SignupForm from 'components/login/signup';
import LoginForm from 'components/login/login';
import ForgotPasswordForm from 'components/login/forgot';
import MobileVerification from 'components/login/mobileVerification';
import VerifyMobileHeader from 'components/login/verifyMobileHeader';
import Icon from './Icon';
import Title from './Title';
import { TextButton } from 'scy/buttons';
import { right } from 'scy/utils.mod.scss';
import { flex, centerItems } from 'scy/flex.mod.scss';
import { trackNow } from 'shared/models/analytic';
import margin from 'scy/margin.mod.scss';

export default function Expanded({ collapse }) {
  const user = useSelector(state => state.login.user || {});

  const [screen, setScreen] = useState(
    user.mobile && !user.mobileVerified ? 'verifyMobile' : 'signup'
  );

  function showLogin() {
    setScreen('login');
    trackNow('Checkout Sign In Clicked');
  }

  function showSignup() {
    setScreen('signup');
    trackNow('Checkout Create Account Clicked');
  }

  function showForgotPassword() {
    setScreen('forgot');
    trackNow('Checkout Forgot Password Clicked');
  }

  function handleSignup(user) {
    if (user && user.mobileVerified) {
      collapse();
    } else {
      setScreen('verifyMobile');
    }
  }

  function handleLogin(user) {
    if (user && user.mobileVerified) {
      collapse();
    } else if (user.mobile) {
      setScreen('verifyMobile');
    } else {
      setScreen('signup');
    }
  }

  return (
    <>
      {screen === 'signup' && _.isEmpty(user) && (
        <TextButton className={right} onClick={showLogin}>
          Sign In
        </TextButton>
      )}

      {screen === 'login' && (
        <TextButton className={right} onClick={showSignup}>
          Create an Account
        </TextButton>
      )}

      {screen === 'forgot' && (
        <TextButton className={right} onClick={showLogin}>
          Sign In
        </TextButton>
      )}

      {screen === 'verifyMobile' && user.mobileVerified && (
        <TextButton className={right} onClick={showSignup}>
          Edit
        </TextButton>
      )}

      <div className={`${flex} ${centerItems} ${margin.bottom_sm}`}>
        <Icon />
        <Title />
      </div>

      {screen === 'signup' && <SignupForm onSuccess={handleSignup} checkout />}

      {screen === 'login' && (
        <LoginForm
          initEmail={user.email}
          showForgotPassword={showForgotPassword}
          onSuccess={handleLogin}
        />
      )}

      {screen === 'forgot' && <ForgotPasswordForm email={user.email} />}

      {screen === 'verifyMobile' && (
        <>
          <VerifyMobileHeader />
          <MobileVerification onSuccess={collapse} />
        </>
      )}
    </>
  );
}
